import {
  PaymentMethod,
  Terminal,
} from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export type OnAfterAddPaymentMethodFn = (
  paymentMethod: PaymentMethod,
  navigation: any
) => Promise<void> | void;

export type OnAfterAddPaymentMethodTerminalFn = (
  paymentMethod: PaymentMethod,
  terminal: Terminal,
  navigation: any
) => Promise<void> | void;

export type OnAfterDeletePaymentMethodFn = (
  navigation: any
) => Promise<void> | void;

export type CreateEditPaymentMethodContextType = {
  onAfterSavePaymentMethod?: OnAfterAddPaymentMethodFn;
  onAfterAddPaymentMethodTerminal?: OnAfterAddPaymentMethodTerminalFn;
  onAfterDeletePaymentMethod?: OnAfterDeletePaymentMethodFn;
};

export const CreateEditPaymentMethodContext = React.createContext<
  CreateEditPaymentMethodContextType | undefined
>(undefined);
